import React from 'react'
import * as Accordion from '@radix-ui/react-accordion'
import classNames from 'classnames'
import getSections from '../../helpers/getSections'

import * as styles from './DesktopFooterWrapper.css'
import locales from '../../helpers/locales'
import {
  AccordionContent,
  AccordionTrigger,
} from '@/components/Accordion/Accordion'
import { FooterProps } from '../footerWrapper'
import BuyFromApp from '../BuyFromApp/BuyFromApp'

function DesktopFooterWrapper({
  lang = 'pt',
  isCollapsible = false,
  variant = 'default',
  onClickOption,
}: FooterProps) {
  return (
    <Accordion.Root
      className={classNames(styles.AccordionRoot)}
      type="single"
      collapsible
      {...(!isCollapsible ? { defaultValue: 'opcoes' } : {})}
    >
      <Accordion.Item value="opcoes">
        <section className={classNames(styles.AccordionContentSection)}>
          <BuyFromApp
            lang={lang}
            accordionImg="https://d1gkntzr8mxq7s.cloudfront.net/67f04b82c8dff.png"
          />
          {getSections(lang).map((section, idx) => (
            <div
              className={classNames(styles.AccordionContentCollumn)}
              key={`section-${idx}`}
            >
              <h4 className={classNames(styles.AccordionContentHeader)}>
                {section.title}
              </h4>
              <AccordionContent
                className={classNames(styles.AccordionContentBody)}
              >
                <ul className={classNames(styles.AccordionContentUl)}>
                  {section.options.map((option, idx) => (
                    <li
                      className={classNames(styles.AccordionContentLi)}
                      key={`section-option-${idx}`}
                    >
                      <a
                        target="_blank"
                        href={option.link}
                        rel="noopener noreferrer"
                        className={classNames(styles.Link)}
                        onClick={() =>
                          onClickOption?.({
                            category: section.title,
                            label: option.name,
                          })
                        }
                      >
                        {option.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </AccordionContent>
            </div>
          ))}
        </section>
        <div className={styles.PositionTrigger}>
          <AccordionTrigger variant={variant}>
            <>
              <span className={classNames('show', styles.ShowOptionText)}>
                {locales[lang as keyof typeof locales]['SHOW_OPTIONS']}
              </span>
              <span className={classNames('hide', styles.ShowOptionText)}>
                {locales[lang as keyof typeof locales]['HIDE_OPTIONS']}
              </span>
            </>
          </AccordionTrigger>
        </div>
      </Accordion.Item>
    </Accordion.Root>
  )
}

export default DesktopFooterWrapper
